// const mxModule = require("mxgraph")();
// const { mxCylinder, mxPoint, mxConnectionConstraint, mxConstants } = mxModule;
import { mxCylinder, mxConstants } from "../utils/graph/mxModule";

function symbolShape() {
  mxCylinder.call(this);
}
symbolShape.prototype = Object.create(mxCylinder.prototype);
symbolShape.prototype.constructor = symbolShape;

// === Pins (Lines) ===
const pinLength = 50; // Change this for longer/shorter pins

symbolShape.prototype.paintVertexShape = function (c, x, y, w, h) {
  const cell = this.state.cell;
  const fontColor = (this.state && this.state.style && this.state.style.fontColor) || '#000000';

  // Get symbol specification data
  const rectWidth = cell.symbolSpec.rect.width;
  const rectHeight = cell.symbolSpec.rect.height;
  const pins = cell.symbolSpec.pins;

  // Determine which sides have pins
  const hasTopPins = pins.some(pin => pin.position === 'top');
  const hasBottomPins = pins.some(pin => pin.position === 'bottom');
  const hasLeftPins = pins.some(pin => pin.position === 'left');
  const hasRightPins = pins.some(pin => pin.position === 'right');

  // Calculate margins based on pin presence
  const marginTop = hasTopPins ? pinLength : 0;
  const marginBottom = hasBottomPins ? pinLength : 0;
  const marginLeft = hasLeftPins ? pinLength : 0;
  const marginRight = hasRightPins ? pinLength : 0;

  // Calculate outer dimensions (should match the vertex geometry)
  const outerWidth = rectWidth + marginLeft + marginRight;
  const outerHeight = rectHeight + marginTop + marginBottom;

  // //This needs to be calculated
  // const symbolDimension = {
  //   width: rectWidth + (2 * pinLength),
  //   height: rectHeight + (2 * pinLength),
  // };

  // === Transparent bounding box (for selection) ===
  c.setFillColor("none");
  c.setStrokeColor("none");
  c.rect(x, y, w, h); //outer rectangle to add constraints.
  c.fillAndStroke();

  // //calculating  symbol's rectangle width and height and place at the center
  // const rectX = x + (w - rectWidth) / 2;
  // const rectY = y + (h - rectHeight) / 2;
  // const rectW = rectWidth;
  // const rectH = rectHeight;

  // Calculate symbol's rectangle position (centered within available space)
  const rectX = x + marginLeft;
  const rectY = y + marginTop;
  const rectW = rectWidth;
  const rectH = rectHeight;

  // Center coordinates
  const centerX = rectX + rectW / 2;
  const centerY = rectY + rectH / 2;

  c.setStrokeColor(this.stroke || "#000000");
  c.setStrokeWidth(1 / this.scale);
  c.setFillColor("none");

  // Draw the rectangle
  c.begin();
  c.rect(rectX, rectY, rectW, rectH); //symbol's rectangle
  c.fillAndStroke();

  // Center label
  c.setFontSize(14 / this.scale);
  c.setFontColor(fontColor);
  const label = cell.symbolName || '';
  c.text( centerX, centerY, rectW, rectH, label, mxConstants.ALIGN_CENTER, mxConstants.ALIGN_MIDDLE, 0, null, 0, 1, 0);

  //Top pins
  c.begin();
  pins.forEach((pin) => {
    switch (pin.position) {
      case "top":
        if (hasTopPins) {
        let tX = rectX + pin.value * rectWidth;
        let tY = rectY;
        c.moveTo(tX, tY);
        c.lineTo(tX, tY - pinLength);
        c.save();
        c.setFontSize(12 / this.scale);
        c.setFontColor(fontColor);
        //c.rotate(angle, flipH, flipV, cx, cy)
        c.rotate(-90, false, false, tX, tY); // rotate text counter-clockwise
        //c.text(x, y, w, h, string, hAlign, vAlign, wrap, format, overflow, clip, rotation)
        c.text(tX, tY, 0, 0, String(pin.name).slice(0, 4), mxConstants.ALIGN_RIGHT, mxConstants.ALIGN_MIDDLE, 0, null, 0, 0, 0);
        c.restore();
        }
        break;
      case "bottom":
        //Bottom pin
        if (hasBottomPins) {
        let bX = rectX + pin.value * rectWidth;
        let bY = rectY + rectHeight;
        c.moveTo(bX, bY);
        c.lineTo(bX, bY + pinLength);
        c.save();
        c.setFontSize(12 / this.scale);
        c.setFontColor(fontColor);
        c.rotate(-90, false, false, bX, bY);
        c.text(bX, bY, 0, 0, String(pin.name).slice(0, 4), mxConstants.ALIGN_LEFT, mxConstants.ALIGN_MIDDLE, 0, null, 0, 0, 0);
        c.restore();
        }
        break;
      case "left":
        // Left pin //y remains same
        if (hasLeftPins) {
        let lX = rectX;
        let lY = rectY + pin.value * rectHeight;
        c.moveTo(lX, lY);
        c.lineTo(lX - pinLength, lY);
        c.save();
        c.setFontSize(12 / this.scale);
        c.setFontColor(fontColor);
        c.text(lX, lY, 0, 0, String(pin.name).slice(0, 4), mxConstants.ALIGN_LEFT, mxConstants.ALIGN_MIDDLE, 0, null, 0, 0, 0);
        c.restore();
        }
        break;
      case "right":
        // Right pin
        if (hasRightPins) {
        let rX = rectX + rectWidth;
        let rY = rectY + pin.value * rectHeight;
        c.moveTo(rX, rY);
        c.lineTo(rX + pinLength, rY);
        c.save();
        c.setFontSize(12 / this.scale);
        c.setFontColor(fontColor);
        c.text(rX, rY, 0, 0, String(pin.name).slice(0, 4), mxConstants.ALIGN_RIGHT, mxConstants.ALIGN_MIDDLE, 0, null, 0, 0, 0);
        c.restore();
        }
        break;
      default:
        break;
    }
  });
  c.stroke();
};

export default symbolShape;
